
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import VueQr from 'vue-qr'

export default {
props: {
text: {
type: String,
default: '手机版'
},
logo: {
type: String,
default: '/../src/assets/logo.png'
},
size: {
type: Number,
default: 260
},
msg: {
type: String,
default: ''
}
},

data () {
return {
showQrCode: false,
config: {
value: 'http://m.xichuangzhu.com',      // 这里放不同的url
fontColor: '#000000'                    
}
}
},

created () {

this.config.value = location.href
console.log('config is ', this.config.value)
},

directives: {
TransferDom
},
components: {
XDialog,
VueQr
},
methods: {
doShowToast () {
this.$vux.toast.show({
text: 'toast'
})
},

toShowQrCode () {
this.showQrCode = true
this.config.value = location.href
}
}
}



// WEBPACK FOOTER //
// ./src/components/QrCodeDialog.vue